function r() {
  return import("quill");
}
export {
  r as lazyImportQuill
};
